export default {
  title: 'Kom i kontakt med oss',
  studentMail: 'Mail for studenter og medlemmer',
  otherMail: 'Mail for andre henvendelser',
};
